import { NextPage } from "next"
import { Seo } from "../components/seo"
import React from "react"

const PrivacyPolicyPage: NextPage = () => {
  return (
    <div className={"container my-16 mx-auto"}>
      <Seo title="Privacy" />
      <article className="prose lg:prose-xl">
        <h3>
          <strong>INFORMAZIONI SUL TRATTAMENTO DEI DATI PERSONALI</strong>
        </h3>
        <h3>
          <strong>
            degli utenti che consultano i siti web della Fondazione Arezzo
            Intour ai sensi dell&apos;articolo 13 del Regolamento (UE) 2016/679
          </strong>
        </h3>
        <h4>
          <strong>PERCHÉ QUESTE INFORMAZIONI</strong>
        </h4>
        <p>
          Ai sensi del Regolamento (UE) 2016/679 (di seguito
          &quot;Regolamento&quot;), questa pagina descrive le modalità di
          trattamento dei dati personali degli utenti che consultano i siti web
          della Fondazione Arezzo Intour (di seguito &quot;LA FONDAZIONE&quot;)
          accessibili per via telematica ai seguenti indirizzi:
        </p>
        <p>
          <a href="https://www.discoverarezzo.com">
            https://www.arezzomedia.com
          </a>
          <u></u>
        </p>
        <p>
          Le presenti informazioni non riguardano altri siti, pagine o servizi
          online raggiungibili tramite link ipertestuali eventualmente
          pubblicati nei siti ma riferiti a risorse esterne ai domini della
          Fondazione.
        </p>
        <h4>
          <strong>TITOLARE DEL TRATTAMENTO</strong>
        </h4>
        <p>
          A seguito della consultazione dei siti sopra riportati possono essere
          trattati dati relativi a persone fisiche identificate o
          identificabili.
        </p>
        <p>
          Titolare del trattamento è Fondazione Arezzo Intour, con sede in
          Arezzo, Via Albergotti, n. 13 – 52100 Arezzo.
        </p>
        <h4>
          <strong>BASE GIURIDICA DEL TRATTAMENTO</strong>
        </h4>
        <p>
          I dati personali indicati in questa pagina sono trattati dalla
          Fondazione Arezzo Intour nell’esecuzione dei propri compiti previsti
          nello statuto della fondazione, ivi incluso il compito di promozione
          della città di Arezzo e della sua immagine turistica.
        </p>
        <h4>
          <strong>TIPI DI DATI TRATTATI E FINALITÀ DEL TRATTAMENTO</strong>
        </h4>
        <p>
          <em>Dati di navigazione</em>
        </p>
        <p>
          I sistemi informatici e le procedure software preposte al
          funzionamento di questo sito acquisiscono, nel corso del loro normale
          esercizio, alcuni dati personali la cui trasmissione è implicita
          nell&apos;uso dei protocolli di comunicazione di Internet.
        </p>
        <p>
          In questa categoria di dati rientrano gli indirizzi IP o i nomi a
          dominio dei computer e dei terminali utilizzati dagli utenti, gli
          indirizzi in notazione URI/URL (Uniform Resource Identifier/Locator)
          delle risorse richieste, l&apos;orario della richiesta, il metodo
          utilizzato nel sottoporre la richiesta al server, la dimensione del
          file ottenuto in risposta, il codice numerico indicante lo stato della
          risposta data dal server (buon fine, errore, ecc.) ed altri parametri
          relativi al sistema operativo e all&apos;ambiente informatico
          dell&apos;utente.
        </p>
        <p>
          Tali dati, necessari per la fruizione dei servizi web, vengono anche
          trattati allo scopo di:
        </p>
        <p>
          ● ottenere informazioni statistiche sull&apos;uso dei servizi (pagine
          più visitate, numero di visitatori per fascia oraria o giornaliera,
          aree geografiche di provenienza, ecc.);
        </p>
        <p>● controllare il corretto funzionamento dei servizi offerti.</p>
        <p>
          I dati di navigazione non persistono per più di sette giorni (salve
          eventuali necessità di accertamento di reati da parte
          dell&apos;Autorità giudiziaria).
        </p>
        <p>
          <em>Dati comunicati dall&apos;utente</em>
        </p>
        <p>
          L&apos;invio facoltativo, esplicito e volontario di messaggi agli
          indirizzi di contatto di Fondazione Arezzo Intour, i messaggi privati
          inviati dagli utenti ai profili/pagine istituzionali sui social media
          (laddove questa possibilità sia prevista), nonché la compilazione e
          l&apos;inoltro dei moduli presenti sui siti della Fondazione
          comportano l&apos;acquisizione dei dati di contatto del mittente,
          necessari a rispondere, nonché di tutti i dati personali inclusi nelle
          comunicazioni.
        </p>
        <p>
          Specifiche informative verranno pubblicate nelle pagine del sito della
          Fondazione predisposte per l&apos;erogazione di determinati servizi.
        </p>
        <p>
          <em>Cookie e altri sistemi di tracciamento</em>
        </p>
        <p>
          Non viene fatto uso di cookie per la profilazione degli utenti, né
          vengono impiegati altri metodi di tracciamento.
        </p>
        <p>
          Viene invece fatto uso di cookie di sessione (non persistenti) in modo
          strettamente limitato a quanto necessario per la navigazione sicura ed
          efficiente dei siti. La memorizzazione dei cookie di sessione nei
          terminali o nei browser è sotto il controllo dell&apos;utente, laddove
          sui server, al termine delle sessioni HTTP, informazioni relative ai
          cookie restano registrate nei log dei servizi, con tempi di
          conservazione comunque non superiori ai sette giorni al pari degli
          altri dati di navigazione.
        </p>
        <p>
          L&apos;elenco completo dei cookie, suddivisi in categorie, utilizzati
          in questo sito web è disponibile al seguente indirizzo:{" "}
          <a href="https://www.discoverarezzo.com/cookie-policy/"> </a>
          <a href="https://www.discoverarezzo.com/cookie-policy/">
            https://www.arezzomedia.com/cookie-policy/
          </a>
          <u></u>
        </p>
        <h4>
          <strong>DESTINATARI DEI DATI</strong>
        </h4>
        <p>
          I dati personali raccolti sono trattati dal personale della Fondazione
          Arezzo Intour, che agisce sulla base di specifiche istruzioni fornite
          in ordine a finalità e modalità del trattamento medesimo.
        </p>
        <h4>
          <strong>DIRITTI DEGLI INTERESSATI</strong>
        </h4>
        <p>
          Gli interessati hanno il diritto di ottenere dall’azienda, nei casi
          previsti, l&apos;accesso ai propri dati personali e la rettifica o la
          cancellazione degli stessi o la limitazione del trattamento che li
          riguarda o di opporsi al trattamento (artt. 15 e ss. del Regolamento).
          L&apos;apposita istanza a Fondazione Arezzo Intour è presentata
          contattando privacy@arezzointour.it
        </p>
        <h4>
          <strong>DIRITTO DI RECLAMO</strong>
        </h4>
        <p>
          Gli interessati che ritengono che il trattamento dei dati personali a
          loro riferiti effettuato attraverso questo sito avvenga in violazione
          di quanto previsto dal Regolamento hanno il diritto di proporre
          reclamo al Garante, come previsto dall&apos;art. 77 del Regolamento
          stesso, o di adire le opportune sedi giudiziarie (art. 79 del
          Regolamento).
        </p>
      </article>
    </div>
  )
}

export default PrivacyPolicyPage
